import { Card, Col, LinkText, Row, Text, TitledText } from '@/components';
import type { LegalBasisModel } from '@/features/project/projects/_models/project';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

export const LegalBasisCard = ({
  legalBasis,
}: {
  legalBasis: z.infer<typeof LegalBasisModel>;
}) => {
  const { t } = useTranslation();

  const {
    id,
    name,
    number,
    article,
    paragraph,
    paragraphSubIndex,
    isManualInput,
  } = legalBasis;

  return (
    <Card>
      <Row gutter={[12, 24]}>
        <Col span={24}>
          {id && !isManualInput ? (
            <LinkText
              text={name}
              href={`https://elaws.e-gov.go.jp/document?lawid=${id}`}
            />
          ) : (
            <Text weight="bold" text={name} />
          )}
        </Col>
        <Col span={12}>
          <TitledText title={t('law-id')} text={id} />
        </Col>
        <Col span={12}>
          <TitledText title={t('law-number')} text={number} />
        </Col>
        <Col span={6}>
          <TitledText title={t('law-article')} text={article} />
        </Col>
        <Col span={6}>
          <TitledText title={t('law-paragraph')} text={paragraph} />
        </Col>
        <Col span={6}>
          <TitledText
            title={t('law-paragraph-sub-index')}
            text={paragraphSubIndex}
          />
        </Col>
      </Row>
    </Card>
  );
};
